<template>
  <div class="contents_wrapper">
    <div class='contents'>
      <h2 class="large_label">案件情報詳細</h2>

      <WorkDataTable :work="work"/>

      <router-link
        v-if="isClient && isEditable"
        :to="{name: 'UpdatingWork', params: {workId: work.id}}"
        class="yellow-ellipse_button">
        作業内容を編集する
      </router-link>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  import COLLECTION_NAMES from "@/assets/js/constants/collection_names";
  import collection from "@/assets/js/functions/firebase/firestore/collection";

  import WorkDataTable from "@/components/objects/table/WorkDataTable";
  import STATUSES from "@/assets/js/constants/statuses";

  export default {
    name: "WorkDetail",

    components: {WorkDataTable},

    mixins: [collection],

    data() {
      return {
        work: {},
      }
    },


    computed: {
      ...mapGetters({uid: 'auth/uid'}),

      isClient() {
        return this.work.client && (this.uid === this.work.client.id)
      },

      isEditable() {
        return (
          STATUSES.SEARCHING.name === this.work.status
          || STATUSES.WAITING.name === this.work.status
          || STATUSES.MEETING.name === this.work.status
          || STATUSES.WORKING.name === this.work.status
        )
      },
    },

    beforeCreate() {
      Object.assign(this, {COLLECTION_NAMES});
    },

    async created() {
      this.workId = location.pathname.replace('/mypage/client/work/detail/', '');
      this.workId = this.workId.replace(/\/*$/, '');

      await this.getDoc(COLLECTION_NAMES.WORKS, this.workId).then(async readWork => {
        this.work = readWork;
      }).catch(() => {
        // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
      });
    },
  }
</script>

<style lang="scss" scoped>
  .contents_wrapper {
    background: linear-gradient(45deg, $client_third, $client_third, $operator_secondary, $operator_secondary);

    > .contents {
      @include index-contents();

      > .user-data_block {
        margin-top: 4rem;
      }

      > .user-data_block, > .operator-data_block {
        width: 100%;
      }
    }
  }
</style>